module.exports = __webpack_public_path__ + "media/images/front/sp/default/noimage_s72x30-c0ac8a78838d103d06481bc2db9f19a1.png";